import { BaseProductType, IconicRange } from '../types/productTypes'
import { BuildConfig } from '../config/BuildConfig'

export function getRangeDisplayName(style: IconicRange | null): string {
  switch (style) {
    case null:
      return ''
    case 'Pro':
      return BuildConfig.brand.copy.ProSeriesRangeDisplayName
    case 'Iconic':
      return style
    case 'Outdoor':
      return style
    default:
      return `Iconic ${style}`
  }
}

export function getRangeMenuDisplayName(style: IconicRange): string {
  switch (style) {
    case 'Pro':
      return 'Pro Series'
    default:
      return style
  }
}

export function getOutdoorTypeDisplayName(outdoorType: BaseProductType): string {
  switch (outdoorType) {
    case 'Switch':
      return 'Switches'
    case 'Socket':
      return 'Power Points'
    case 'Other':
      return 'Conduit Fittings'
  }
}